import { useQuery } from '@tanstack/react-query'

import { ApiKey, PlanServicesEnum } from 'features/incidents/components/enums'
import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'

type PolicyParameterParams = {
  type: PlanServicesEnum
}

export const getInventoryListist = (params: PolicyParameterParams) => {
  return axios.get(endpoints.getInventory, { params })
}

export const useGetInventoryList = (params: PolicyParameterParams) => {
  return useQuery([ApiKey.INVENTORY, ApiKey.list, params], () => getInventoryListist(params))
}
